import { useConfiguration } from '../../../../context/configurationContext';
import { H2 } from '../../Primitives/Heading';
import { P } from '../../Primitives/P';
import PopularCar from './PopularCar';
import css from './SectionPopularCars.module.css';

const SectionPopularCars = ({ listings, description, title }) => {
  const config = useConfiguration().listing.listingFields;
  if (listings.length === 0) return null;

  //   const existingListingFields = config.reduce(pickListingFields, []);

  return (
    <div className={css.popularCars_wrapper}>
      <H2 className={css.cars_title}>{title.content}</H2>
      <P className={css.cars_subtitle}>{description.content}</P>
      <div className={css.popularCars}>
        {listings.map(car => (
          <PopularCar key={car.imageUrl} car={car} config={config} />
        ))}
      </div>
    </div>
  );
};

export default SectionPopularCars;
